export const NAV_NONE_SELECTED = 'NAV_NONE_SELECTED';
export const NAV_IMAGE_SELECTED = 'NAV_IMAGE_SELECTED';
export const NAV_BOOK_SELECTED = 'NAV_BOOK_SELECTED';
export const NAV_LAYOUTS_SELECTED = 'NAV_LAYOUTS_SELECTED';
export const NAV_TEXT_SELECTED = 'NAV_TEXT_SELECTED';
export const NAV_FUNDOS_SELECTED = 'NAV_FUNDOS_SELECTED';
